export default __webpack_public_path__ + "8459dae7ab52c3c79aabedab3f000c06.png";